module.exports = __webpack_public_path__ + "img/item_CommIllustration_01b.e8560911.jpeg";